
<div class="app">
  <app-header *ngIf="header"></app-header>

  <main class="app--main">
    <router-outlet></router-outlet>
  </main>

  <app-footer *ngIf="footer"></app-footer>
</div>

<!-- Aplicación deshabilitada temporalmente por mantenimiento
<div class="maintenance-page">
  <div class="maintenance-container">
    <div class="maintenance-icon">🛠️</div>

    <h1>Aplicación en mantenimiento</h1>

    <p>
      Estamos realizando tareas de mantenimiento para mejorar el servicio.
      Durante este período la aplicación puede no estar disponible temporalmente.
    </p>

    <div class="maintenance-status">
      Mantenimiento programado
    </div>

    <div class="maintenance-footer">
      Gracias por tu comprensión.<br />
      Equipo de Soporte
    </div>
  </div>
</div>
<style>
  .maintenance-page {
    width: 100%;
    min-height: 100vh;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
    background: linear-gradient(135deg, #003366, #005a9c);
    font-family: "Segoe UI", Arial, sans-serif;
    box-sizing: border-box;
  }

  .maintenance-page * {
    box-sizing: border-box;
  }

  .maintenance-container {
    width: 100%;
    max-width: 700px;
    padding: 50px;
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(8px);
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  }

  .maintenance-icon {
    margin-bottom: 20px;
    font-size: 80px;
  }

  .maintenance-container h1 {
    margin: 0 0 20px;
    font-size: 2.5rem;
  }

  .maintenance-container p {
    margin: 0;
    font-size: 1.1rem;
    line-height: 1.6;
    opacity: 0.95;
  }

  .maintenance-status {
    display: inline-block;
    margin-top: 30px;
    padding: 12px 24px;
    color: #333;
    font-weight: bold;
    background: #ffb900;
    border-radius: 30px;
  }

  .maintenance-footer {
    margin-top: 40px;
    font-size: 0.9rem;
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    .maintenance-container {
      padding: 30px;
    }

    .maintenance-icon {
      font-size: 60px;
    }

    .maintenance-container h1 {
      font-size: 2rem;
    }
  }
</style>
-->